import styled from 'styled-components';

import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurSpacing,
    getPurpurTypography,
    purpurMedia,
} from '@telialt/common-theme/src/purpurSelectors';

import { sideSpacingOfHeaderFooter } from '../../OrderCart.styles';

export const CartGroupTotals = styled.dl`
    ${sideSpacingOfHeaderFooter};
    ${purpurMedia('sm')`
        padding-top: ${getPurpurSpacing('250')};
    `}
    ${purpurMedia('md')`
        padding-top: ${getPurpurSpacing('300')};
    `}
    display: grid;
    grid-template-columns: 1fr auto;
    row-gap: ${getPurpurSpacing('50')};
    margin: 0;
`;

export const TermMonthly = styled.dt`
    font-size: ${getPurpurTypography('scale100')};
    font-weight: ${getPurpurTypography('weightNormal')};
`;
export const ValueMonthly = styled.dd`
    font-size: ${getPurpurTypography('scale100')};
    font-weight: ${getPurpurTypography('weightBold')};
    text-align: right;
`;

export const TermTotal = styled.dt`
    font-size: ${getPurpurTypography('scale200')};
    ${purpurMedia('md')`   
        font-size: ${getPurpurTypography('scale400')};
    `}
    font-weight: ${getPurpurTypography('weightBold')};
`;
export const ValueTotal = styled.dd`
    font-size: ${getPurpurTypography('scale200')};
    ${purpurMedia('md')`   
        font-size: ${getPurpurTypography('scale400')};
    `}
    font-weight: ${getPurpurTypography('weightBold')};
    text-align: right;
`;

export const Separator = styled.div`
    grid-column: 1/-1;
    width: 100%;
    margin: ${getPurpurSpacing('100')} 0;
    border-top: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('borderWeak')};
    &:first-child,
    &:last-child {
        display: none;
    }
`;
